module.exports = {
  prefix: 'fac',
  iconName: 'layout-thumbnail',
  icon: [
    512, 512,
    [],
    null,
    'M0 144.69c0,-24.59 19.93,-44.52 44.52,-44.52l422.96 0c24.59,0 44.52,19.93 44.52,44.52l0 222.61c0,24.59 -19.93,44.53 -44.52,44.53l-422.96 0c-24.59,0 -44.52,-19.94 -44.52,-44.53l0 -222.61 0 0zm44.52 22.27c0,-12.3 9.97,-22.27 22.26,-22.27l378.44 0c12.29,0 22.26,9.97 22.26,22.27l0 178.08c0,12.3 -9.97,22.26 -22.26,22.26l-378.44 0c-12.29,0 -22.26,-9.96 -22.26,-22.26l0 -178.08zm244.87 22.25c-12.3,0 -22.26,9.97 -22.26,22.26 0,12.3 9.96,22.27 22.26,22.27l111.31 0c12.29,0 22.26,-9.97 22.26,-22.27 0,-12.29 -9.97,-22.26 -22.26,-22.26l-111.31 0zm-22.26 111.31c0,-12.3 9.96,-22.26 22.26,-22.26l111.31 0c12.29,0 22.26,9.96 22.26,22.26 0,12.29 -9.97,22.26 -22.26,22.26l-111.31 0c-12.3,0 -22.26,-9.97 -22.26,-22.26zm-178.09 22.26l0 -133.57 133.57 0 0 133.57 -133.57 0z'
  ]
};


// WEBPACK FOOTER //
// ./src/icons/layouts/faLayoutThumbnail.js